import { useSelector } from "react-redux"
import useIsCorpView from "../../../../hooks/useIsCorpView"
import { selectChildHasDE } from "../../../../redux/childCustomer"
import { selectHasDE } from "../../../../redux/customer"

const useHasDE = () => {
  const isCorpView = useIsCorpView()

  const hasDE = useSelector(
    isCorpView ? selectChildHasDE : selectHasDE
  )

  return hasDE
}

export default useHasDE
